import { Link } from "gatsby"
import React from "react"
import useArticlePath from "../../hooks/useArticlePath"
import useProductPath from "../../hooks/useProductPath"
import useRoutePath from "../../hooks/useRoutePath"
import useWebsite from "../../hooks/useWebsite"
import Button from "../atoms/Button"
import ExternalLink from "../atoms/ExternalLink"
// import styles from "./DatoInlineRecord.module.scss"

export type DatoInlineRecordProps =
  | ({ __typename: "DatoCmsRouteLink" } & Queries.DatoRouteLinkFragment)
  | ({ __typename: "DatoCmsProductLink" } & Queries.DatoProductLinkFragment)
  | ({ __typename: "DatoCmsProductFinderLink" } & Queries.DatoProductFinderLinkFragment)
  | ({ __typename: "DatoCmsArticleLink" } & Queries.DatoArticleLinkFragment)
  | ({ __typename: "DatoCmsExternalUrl" } & Queries.DatoExternalUrlFragment)

/**
 * Mappaa structured text inline recordit React komponentteihin
 */
const DatoInlineRecord = (props: DatoInlineRecordProps) => {
  const website = useWebsite()
  const getProductPath = useProductPath()
  const getArticlePath = useArticlePath()
  const getRoutePath = useRoutePath()

  switch (props.__typename) {
    case "DatoCmsRouteLink": {
      const target = getRoutePath(props.route?.originalId)
      return (
        <Link to={`${target || ""}${props.urlParams || ""}`}>
          <Button label={props.title} />
        </Link>
      )
    }
    case "DatoCmsProductLink": {
      const target = getProductPath(props.sku)
      return (
        <Link to={`${target}`}>
          <Button label={props.title || props.sku} />
        </Link>
      )
    }
    case "DatoCmsProductFinderLink": {
      const path = getRoutePath(website.productRootRoute?.originalId)
      return (
        <Link to={`${path}${props.searchQuery || ""}`}>
          <Button label={props.title} />
        </Link>
      )
    }
    case "DatoCmsArticleLink": {
      const target = getArticlePath(props.article?.originalId)
      return (
        <Link to={`${target}${props.urlParams || ""}`}>
          <Button label={props.title || props.article?.title} />
        </Link>
      )
    }
    case "DatoCmsExternalUrl":
      // TODO i18n "Go to"
      return (
        props.url && (
          <ExternalLink href={props.url}>
            <Button label={`Go to ${props.title}`} />
          </ExternalLink>
        )
      )

    default:
      console.warn("Unhandled InlineRecord", (props as any).__typename)
      return null
  }
}

export default DatoInlineRecord
